var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-751 -606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(751 606)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "market",
    transform: "translate(753 610.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M26.359,106.684v35.425a.427.427,0,0,0,.427.427h46.69a.427.427,0,0,0,.427-.427V106.684Zm0,0",
    transform: "translate(-23.631 -95.192)",
    fill: "#ed5176"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2.729 11.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M26.359,224.047H73.9v2.407H26.359Zm0,0",
    transform: "translate(-26.359 -211.898)",
    fill: "#ba365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M26.359,106.684H73.9v2.407H26.359Zm0,0",
    transform: "translate(-26.359 -106.684)",
    fill: "#ba365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M174.426,106.684v2.424a3.092,3.092,0,0,0,3.092,3.092h13.058a3.991,3.991,0,0,0,3.991-3.991v-1.524Zm0,0",
    transform: "translate(-159.099 -106.684)",
    fill: "#ba365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M457.654,106.684v35.425a.427.427,0,0,1-.427.427h2.515a.427.427,0,0,0,.427-.427V106.684Zm0,0",
    transform: "translate(-412.625 -106.684)",
    fill: "#ba365f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M201.07,289.832v15.937h11.372V289.832a1.067,1.067,0,0,0-1.067-1.067h-9.239a1.067,1.067,0,0,0-1.066,1.067Zm0,0",
    transform: "translate(-180.256 -258.425)",
    fill: "#6a7193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M202.7,291.46a1.067,1.067,0,0,1,1.067-1.067h8.679v-.561a1.067,1.067,0,0,0-1.066-1.067h-9.239a1.067,1.067,0,0,0-1.067,1.067v15.937H202.7Zm0,0",
    transform: "translate(-180.256 -258.426)",
    fill: "#575b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M.641,174.177v4.353a.426.426,0,0,0,.427.427H53.081a.426.426,0,0,0,.427-.427v-4.353a.426.426,0,0,0-.427-.427H1.067a.426.426,0,0,0-.427.427Zm0,0",
    transform: "translate(-0.574 -155.316)",
    fill: "#c8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M485.544,173.75h-2.505a.426.426,0,0,1,.427.427v4.354a.427.427,0,0,1-.427.427h2.505a.427.427,0,0,0,.427-.427v-4.354A.426.426,0,0,0,485.544,173.75Zm0,0",
    transform: "translate(-433.037 -155.316)",
    fill: "#8cbcd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M344.6,306.188v8.728a.9.9,0,0,0,.9.9h9.9a.9.9,0,0,0,.9-.9v-8.728a.9.9,0,0,0-.9-.9h-9.9A.9.9,0,0,0,344.6,306.188Zm0,0",
    transform: "translate(-308.927 -273.235)",
    fill: "#c8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M54.34,306.188v8.728a.9.9,0,0,0,.9.9h9.9a.9.9,0,0,0,.9-.9v-8.728a.9.9,0,0,0-.9-.9h-9.9A.9.9,0,0,0,54.34,306.188Zm0,0",
    transform: "translate(-48.715 -273.235)",
    fill: "#c8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M53,67.046V65.09H0v1.956A2.35,2.35,0,0,1,2.35,69.4h48.3A2.35,2.35,0,0,1,53,67.046Zm0,0",
    transform: "translate(0 -57.904)",
    fill: "#c8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M174.426,65.09h20.141V69.4H174.426Zm0,0",
    transform: "translate(-156.37 -57.904)",
    fill: "#8cbcd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M467.448,65.09v1.956a2.35,2.35,0,0,0-2.35,2.35H467.6a2.35,2.35,0,0,1,2.35-2.35V65.09Zm0,0",
    transform: "translate(-416.953 -57.904)",
    fill: "#8cbcd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M158.715,3.592v8.727a3.092,3.092,0,0,0,3.092,3.092h13.958a3.092,3.092,0,0,0,3.092-3.092V3.592A3.092,3.092,0,0,0,175.764.5H161.807A3.092,3.092,0,0,0,158.715,3.592Zm0,0",
    transform: "translate(-142.286)",
    fill: "#ffeb96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M213.858,364.948h-.64a.776.776,0,0,1,0-1.553h.64a.776.776,0,0,1,0,1.553Zm0,0",
    transform: "translate(-190.45 -325.33)",
    fill: "#252d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M202.651,31.8H197.9a2.007,2.007,0,0,1-1.956-1.59l-1.01-4.826h-1a.776.776,0,0,1,0-1.553h1a1.56,1.56,0,0,1,1.52,1.235l1.009,4.826a.448.448,0,0,0,.436.355h4.75a.448.448,0,0,0,.417-.288l1.42-3.759h-6.3a.776.776,0,0,1,0-1.553h6.717a1.262,1.262,0,0,1,1.181,1.708l-1.569,4.152a2.009,2.009,0,0,1-1.869,1.292Zm0,0",
    transform: "translate(-173.165 -20.921)",
    fill: "#5692d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M231.72,109.295h-.213a.776.776,0,0,1,0-1.553h.213a.776.776,0,0,1,0,1.553Zm0,0",
    transform: "translate(-206.846 -96.141)",
    fill: "#5692d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M265.2,109.295h-.213a.776.776,0,0,1,0-1.553h.213a.776.776,0,0,1,0,1.553Zm0,0",
    transform: "translate(-236.861 -96.141)",
    fill: "#5692d8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c9edcb0815db2fc603ddb3a186207a7d.svg";
export { ForwardRef as ReactComponent };